module.exports = __webpack_public_path__ + "static/about-this-program-e3d8107b802add2e572ddcd59db0b4e3.png";